import { CommonModule } from "@angular/common";
import { Component, DestroyRef, inject, signal } from "@angular/core";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { TranslateModule } from "@ngx-translate/core";
import { filter } from "rxjs/operators";

@Component({
  selector: "mobile-pwa-update-banner",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./pwa-update-banner.component.html",
  styleUrl: "./pwa-update-banner.component.scss",
})
export class PwaUpdateBannerComponent {
  private readonly swUpdate = inject(SwUpdate);
  private readonly destroyRef = inject(DestroyRef);
  readonly isVisible = signal(false);

  constructor() {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    const subscription = this.swUpdate.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === "VERSION_READY"))
      .subscribe(() => this.isVisible.set(true));

    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }

  reload(): void {
    window.location.reload();
  }
}
